import { ActionRules } from '@/type';
import recognition from '@/auth/recognition';

export default class AccessChecker {
  rules: ActionRules;

  constructor(rules: ActionRules) {
    this.rules = rules;
  }

  isGranted(action: string, ...args: any[]): boolean {
    const rule = this.rules[action];
    if (!rule) return false;

    if (rule.accountTypes && rule.accountTypes.length) {
      const accountType = recognition.getAccountType();
      if (accountType === null || !rule.accountTypes.includes(accountType)) return false;
    }
    if (rule.scope && !recognition.hasScope(rule.scope)) return false;
    if (rule.check) {
      return rule.check(...args);
    }
    return true;
  }
}
